import { Table as TableComponent } from './Table';
import { AmountCell, Cell, ChipCell, OptionCell, TextCell, TimeCell } from './cells';
import { ColumnSelector } from './header';
export { TableVariant } from './types';
export const Table = Object.assign(TableComponent, {
    AmountCell: AmountCell,
    Cell: Cell,
    ChipCell: ChipCell,
    ColumnSelector: ColumnSelector,
    OptionCell: OptionCell,
    TextCell: TextCell,
    TimeCell: TimeCell,
});
//# sourceMappingURL=index.js.map